import { createAction, createReducer } from 'redux-act'
import Immutable from 'seamless-immutable'


export const key = 'app'

//
// Initial state
//
const initialState = {
  menus: null,
  isInit: false,
  langKey: null,
  navOpen: false,
}

//
// Actions
//
export const actions = {
  init: createAction('App: init'),
  setMenus: createAction('App: setMenus', menus => menus),
  setIsInit: createAction('App: setIsInit', isInit => isInit),
  setLangKey: createAction('App: setLangKey', langKey => langKey),
  setNavOpen: createAction('App: setNavOpen', navOpen => navOpen),
}

//
// Reducer
//
export const reducer = createReducer(
  {
    [actions.setMenus]: (state, menus) => Immutable.merge(state, { menus }),
    [actions.setIsInit]: (state, isInit) => Immutable.merge(state, { isInit }),
    [actions.setLangKey]: (state, langKey) => Immutable.merge(state, { langKey }),
    [actions.setNavOpen]: (state, navOpen) => Immutable.merge(state, { navOpen }),
  },
  initialState
)

//
// Selectors
//
const root = state => state[key]
const menus = state => root(state).menus
const isInit = state => root(state).isInit
const langKey = state => root(state).langKey
const isNavOpen = state => root(state).navOpen

export const selectors = {
  menus,
  isInit,
  langKey,
  isNavOpen,
}
